export const moduleName = 'councilUnits';

export const tabNames = Object.freeze({
  UNITS: 'units',
  RECENT_UNITS: 'recent',
});

export const expireDateFormat = 'MMM D, YYYY';
